module.exports = __webpack_public_path__ + "fae45f90c5aba3841fb7d69e20e3f3a3.pdf";